interface GridViewIcon2Props {
  fill?: string;
  width?: number;
  height?: number;
  [key: string]: any;
}

const GridViewIcon2 = (props: GridViewIcon2Props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_25849_61670"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={21}
    >
      <rect y={0.5} width={20} height={20}  />
    </mask>
    <g mask="url(#mask0_25849_61670)">
      <path
        d="M5.83333 14.6667H9.16667V11.3333H5.83333V14.6667ZM10.8333 14.6667H14.1667V11.3333H10.8333V14.6667ZM5.83333 9.66667H9.16667V6.33333H5.83333V9.66667ZM10.8333 9.66667H14.1667V6.33333H10.8333V9.66667ZM4.16667 18C3.70833 18 3.31597 17.8368 2.98958 17.5104C2.66319 17.184 2.5 16.7917 2.5 16.3333V4.66667C2.5 4.20833 2.66319 3.81597 2.98958 3.48958C3.31597 3.16319 3.70833 3 4.16667 3H15.8333C16.2917 3 16.684 3.16319 17.0104 3.48958C17.3368 3.81597 17.5 4.20833 17.5 4.66667V16.3333C17.5 16.7917 17.3368 17.184 17.0104 17.5104C16.684 17.8368 16.2917 18 15.8333 18H4.16667ZM4.16667 16.3333H15.8333V4.66667H4.16667V16.3333Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
export default GridViewIcon2;
